import colors from './colors';

const buttons = {
  primary: {
    default: {
      font: '#4a4a4a',
      background: '#ffdc00',
      border: 'transparent'
    },
    hovered: {
      background: '#d6b900'
    },
    focused: {
      background: '#d6b900'
    },
    disabled: {
      font: '#c8c9c7',
      background: '#97999b'
    },
  },
  secondary: {
    default: {
      font: '#006fcf',
      border: '#006fcf'
    },
    hovered: {
      background: 'rgba(229, 229, 229, 0.2)'
    },
    focused: {
      background: 'rgba(229, 229, 229, 0.2)'
    },
    disabled: {
      font: '#c8c9c7',
      border: '#c8c9c7',
      background: 'rgba(247, 248, 249, 0.3)'
    },
    inverted: {
      font: 'white',
      border: 'white'
    }
  },
  tertiary: {
    default: {
      font: '#006fcf',
      background: ''
    },
    hovered: {
      font: '#0058a3'
    },
    focused: {
      font: '#0058a3'
    },
    disabled: {
      font: '#c8c9c7'
    },
    inverted: {
      font: 'white'
    }
  },
  chevron: {
    default: {
      font: '#4a4a4a',
      border: '#c8c9c7',
      background: '#f7f8f9',
    },
    hovered: {
      background: '#c5c6c7'
    },
    focused: {
      background: '#c5c6c7'
    },
    disabled: {
      font: '#c8c9c7',
      background: '#f7f8f9'
    },
  },
  brandButton: {
    default: {
      background: colors.brand01,
      font: colors.text02,
    },
    hovered: {
      background: colors.darkYellow,
    },
    focused: {
      background: colors.darkerYellow,
    },
    disabled: {
      font: colors.text04,
      background: colors.ui02,
    },
  },
  neutralButton: {
    default: {
      background: colors.ui03,
      font: colors.text02,
    },
    hovered: {
      background: colors.backgroundGray2,
    },
    focused: {
      background: colors.backgroundGray3,
      font: colors.text01,
    },
    disabled: {
      font: colors.text04,
      background: colors.ui02,
    },
  },
  longModalButton: {
    primary: {
      background: colors.ui02,
      font: colors.text01,
    },
    secondary: {
      font: colors.text02
    },
  },
  baseButton: {
    default: {
      background: colors.white,
      font: colors.text02,
    },
    hovered: {
      font: colors.text01,
    },
    focused: {
      font: colors.text02,
    },
    disabled: {
      font: colors.text04,
    },
  }
};

export default buttons;
